module.exports = __webpack_public_path__ + "img/AnestheticNote-Icon.8449715e.png";